import React from 'react';
import MiniSocialGraph from './MiniSocialGraph.js';
import { type Alert, type Suspect } from '../api/types.js';
import { useTranslation } from '../i18n/useTranslation.js';

interface AlertPanelProps {
  alerts: Array<Alert>;
  suspects: Record<string, Suspect>;
  onSelectSuspect: (id: string) => void;
}

function AlertPanel({ alerts, suspects, onSelectSuspect }: AlertPanelProps) {
  const { t } = useTranslation();
  return (
    <div className="panel-r">
      {/* Top section: Alerts */}
      <div className="pr-section pr-top">
        <div className="ph">
          <div className="ph-top">
            <span className="ph-title">{t('alertPanel.alerts')}</span>
          </div>
        </div>
        <div className="pb">
          {alerts.map((a, i) => (
            <div key={i} className={`ai ${a.t}`}>
              <div className="atop">
                <span className={`att ${a.t}`}>
                  {a.t === 'c' && <span className="np" />}
                  {a.title}
                </span>
                <span className="atm">{a.time}</span>
              </div>
              <div className="abody">{a.body}</div>
              <div className="ame">
                {a.loc && <span className="atg loc">📍 {a.loc}</span>}
                <span className="atg sus">👤 {a.sus}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom section: Social Graph */}
      <div className="pr-section pr-bottom">
        <div className="ph">
          <div className="ph-top">
            <span className="ph-title">{t('alertPanel.socialGraph')}</span>
          </div>
        </div>
        <MiniSocialGraph suspects={suspects} onSelectSuspect={onSelectSuspect} />
      </div>
    </div>
  );
}

export default AlertPanel;
